import type { CSSProperties, ElementType, FC, ReactNode } from 'react'

import { useInView } from '@/hooks/use-in-view'

interface RevealProps {
    children?: ReactNode
    as?: ElementType
    delay?: number
    y?: number
    /** Final rotation in degrees. Turns the reveal into a pinned-print settle. */
    settle?: number
    className?: string
    style?: CSSProperties
    id?: string
}

export const Reveal: FC<RevealProps> = ({
    children,
    as: Tag = 'div',
    delay = 0,
    y,
    settle,
    className,
    style,
    id
}) => {
    const { ref, inView } = useInView<HTMLElement>()

    const vars = {
        ...style,
        '--delay': `${delay}ms`,
        ...(y === undefined ? {} : { '--reveal-y': `${y}px` }),
        ...(settle === undefined ? {} : { '--settle-to': `${settle}deg`, '--settle-from': `${settle > 0 ? settle + 5 : settle - 5}deg` })
    } as CSSProperties

    return (
        <Tag
            ref={ref}
            id={id}
            data-reveal=''
            data-settle={settle === undefined ? undefined : ''}
            data-revealed={inView ? '' : undefined}
            className={className}
            style={vars}
        >
            {children}
        </Tag>
    )
}
